import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Router } from '@angular/router';
import { PLAY_STORE_URL } from '../../../Shared/app-store-links';

@Component({
  selector: 'app-features',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './features.html',
  styleUrl: './features.css',
})
export class Features {
  constructor(private router: Router) {}

  goToPricing(): void {
    this.router.navigate(['/pricing']);
  }

  goToApps(): void {
    this.router.navigate(['/product']);
  }

  openPosApp(): void {
    if (PLAY_STORE_URL) window.open(PLAY_STORE_URL, '_blank');
  }
}